module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor-main",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    ref: "editor",
    staticClass: "editor fl",
    style: (_vm.edstyle)
  }, [(!_vm.ispreview) ? _c('draggable', {
    staticClass: "phonetop",
    attrs: {
      "options": {
        group: {
          name: 'phonetop',
          pull: false,
          put: false
        },
        scroll: false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/top.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    style: (_vm.scstyle),
    attrs: {
      "id": "scroll_container"
    }
  }, [_c('div', [_c('draggable', {
    style: (_vm.pagestyle),
    attrs: {
      "id": "canvas",
      "options": {
        disabled: _vm.ispreview,
        group: {
          name: 'sort1',
          pull: false
        },
        handle: '.myhandler',
        ghostClass: 'sortghost',
        scroll: true
      }
    },
    model: {
      value: (_vm.tree_modules),
      callback: function($$v) {
        _vm.tree_modules = $$v
      },
      expression: "tree_modules"
    }
  }, [_vm._l((_vm.tree_modules), function(child, m) {
    return _c('wp-module', {
      key: child.id,
      attrs: {
        "id": child.id,
        "mod_param": child.orimodinf,
        "children": child.children,
        "is_active": child.active,
        "active": child.active,
        "position": 'relative',
        "islast": (_vm.tree_modules.length == m + 1) ? true : false
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "place-holder",
    style: ({
      'height': _vm.placeholder_height + 'px'
    })
  })], 2)], 1)]), _vm._v(" "), (!_vm.ispreview) ? _c('draggable', {
    staticClass: "phonebottom",
    style: ({
      'top': (_vm.btmtop + "px")
    }),
    attrs: {
      "options": {
        group: {
          name: 'phonetop',
          pull: false,
          put: false
        },
        scroll: false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/bottom.png")
    }
  })]) : _vm._e()], 1), _vm._v(" "), (!_vm.ispreview) ? _c('div', {
    staticClass: "propanel fr"
  }, [_c('property', {
    attrs: {
      "attrs": _vm.propInfo,
      "height": _vm.height
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show_setdialog && !_vm.ispreview) ? _c('setting') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-39032d14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/editor.vue
// module id = 187
// module chunks = 2